import { useTranslation } from "react-i18next";

const PageNotWorking = () => {
  const { t } = useTranslation("clientView");

  return (
    <div className="w-full min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="container mx-auto flex flex-wrap items-center justify-center gap-4">
        <img
          src="https://cdn.1cdn.app/application/UMD/23070305535988_not-working-page.svg"
          alt=""
        />
        <div className="flex flex-col items-start justify-start gap-2">
          <h1>{t("dashboard.features.loginTemplate.pageNotWorking.header")}</h1>
          <h5>
            {t(
              "dashboard.features.loginTemplate.pageNotWorking.description-01"
            )}
          </h5>
        </div>
      </div>
    </div>
  );
};

export default PageNotWorking;
